import styled from '@emotion/styled/macro'
import { Box } from 'theme-ui'

import { WithTheme } from './../../../setup/index'
import media from './../../../common/MediaQueries'

const CardIconStyled = styled.div`
  margin: 0 auto 0.75rem;
  font-size: 2.5rem;

  .lazy-load-image-background img {
    max-height: 4.6875rem;
    width: 100%;
  }
`

const CardTitleStyled = styled.div`
  margin-bottom: 0.5rem;
  @media ${media.phone} {
    margin-bottom: 0.75rem;
  }
`

const CardDescStyled = styled.div`
  margin-bottom: 1.875rem;
`

const CardActionStyled = styled(Box)<WithTheme>`
  margin-top: auto;
  transition: ${({ theme }) => theme.transitions.default};
  color: ${({ theme }) => theme.colors.gray3};
`

const CardStyled = styled(Box)<WithTheme>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.625rem;
  box-shadow: -1px 3px 10px 0px rgba(0, 0, 0, 0.04);
  transition: ${({ theme }) => theme.transitions.default};
  height: 100%;
  padding: 1.25rem 1.625rem 1.0625rem;
  @media ${media.phone} {
    padding: 1.25rem 1.25rem 1.375rem;
  }

  &:hover {
    box-shadow: none;
    ${CardActionStyled} {
      color: ${({ theme }) => theme.colors.green};
    }
  }
`

export { CardStyled, CardIconStyled, CardTitleStyled, CardDescStyled, CardActionStyled }
